import React from 'react'
import logo from '../../Assets/logo.png'
import right_arrow_white from '../../Assets/icons/right_arrow_white.svg'
import Social from '../../Components/Social/Social'


function Footer() {
  return (
    <div className='w-full bg-[#ffffff] pb-5'>
      <div className='w-full sectionlayout poppins'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 text-[#6c6c6c] py-8'>
          <div>
            <img src={logo} alt="" className='max-h-[9vh] max-w-[70%] md:max-h-[60px] md:max-w-[220px]' />
            <p className='mt-4 text-[14px]'>Gulberg Green Islamabad</p>
            <p className='mt-4 text-[14px]'>dynamicleo@gmail.com</p>
            <p className='mt-4 text-[14px]'>+92 347 5615338</p>
          </div>
          <div>
            <p className='text-[18px] font-semibold mt-8 md:mt-1 mb-4 relative'>Quick Links <span className='absolute left-0 bottom-[-20px] w-[50px] h-[4px] bg-[#b6861f]'></span></p>
            <p className='mt-[35px] md:mt-[55px] text-[14px]'>Home</p>
            <p className='mt-3 text-[14px]'>Who are we</p>
            <p className='mt-3 text-[14px]'>What we offer</p>
            <p className='mt-3 text-[14px]'>Contact Us</p>
          </div>
          <div>
            <p className='text-[18px] font-semibold mt-8 md:mt-1 mb-4 relative'>Services <span className='absolute left-0 bottom-[-20px] w-[50px] h-[4px] bg-[#b6861f]'></span></p>
            <p className='mt-[35px] md:mt-[55px] text-[14px]'>E-Commerce</p>
            <p className='mt-3 text-[14px]'>Dropshipping</p>
            <p className='mt-3 text-[14px]'>IT-Solutions</p>
          </div>
          <div>
            <p className='text-[18px] font-semibold  mt-8 lg:mt-1 mb-4 relative'>Subscribe <span className='absolute left-0 bottom-[-20px] w-[50px] h-[4px] bg-[#b6861f]'></span></p>
            <div className='md:w-full mt-[45px] flex mb-5'>
              <input type="text" placeholder='Get product updates' className='p-4 w-[80%] border font-normal text-[14px] rounded-tl-[10px] rounded-bl-[10px] focus:border-blue-500 focus:outline-none' />
              <button type='submit' className='p-4 w-[20%] font-normal text-[14px] bg-[#478EFF] flex items-center justify-center rounded-tr-[10px] rounded-br-[10px]'><img src={right_arrow_white} alt="" /></button>
            </div>
            <div className='flex md:block items-center justify-center'>
              <Social />
            </div>
          </div>
        </div>
        <p className="text-[#6c6c6c] text-center md:text-left">© 2024 Dynamic Leo. All rights reserved</p>
      </div>
    </div>
  )
}
export default Footer
